import QuickView from '../../components/quickView';

let quickViewModals

if ($('.article').length) {
  quickViewModals = new QuickView('.modal');
}

const openQuickViewModalBtns = document.querySelectorAll('.quick-view button');
const displayQuickViewModal = function(e) {
  e.preventDefault();

  let target = e.target;
  while (!target.classList.contains('quick-view')) {
    target = target.parentElement;
  }

  const productId = target.dataset.productid;
  const variantId = target.dataset.variantid;
  const modal = document.getElementById(`quick-view-${productId}`);

  if (quickViewModals != undefined) {
    quickViewModals.previewVariant(modal, undefined, variantId);
  };

  modal.style.display = 'flex';
};

openQuickViewModalBtns.forEach(button => {
  button.addEventListener('click', displayQuickViewModal);
});
